import { useEffect, useState } from "react";
import {
  ProductsDataType,
  WeeklyProdcutsDataType,
} from "../../interfaces/admin.interface";
import { Helmet } from "react-helmet";
import { Input, Modal, Spin, Table, TableProps } from "antd";
import MainButton from "../../components/shared/MainButton/MainButton";
import Spinner from "../../components/shared/Spinner/Spinner";
import { FaEdit } from "react-icons/fa";
import { WeeklyProductsService } from "../../services/weekly_picks.service";
import styles from "./WeeklyPicks.module.scss";
import { ProductsService } from "../../services/products.service";

const WeeklyPicks = () => {
  const [weeklyProducts, setWeeklyProducts] = useState<
    WeeklyProdcutsDataType[]
  >([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [products, setProducts] = useState<ProductsDataType[]>([]);
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);

  useEffect(() => {
    setLoading(true);
    WeeklyProductsService.getAllProducts()
      .then((response) => {
        if (Array.isArray(response?.data?.data)) {
          const dataWithKeys = response?.data?.data?.map(
            (item: WeeklyProdcutsDataType, index: number) => ({
              ...item,
              key: index + 1,
            })
          );
          setWeeklyProducts(dataWithKeys);
          const selectedIds = dataWithKeys.map(
            (item: WeeklyProdcutsDataType) => item.product.id
          );
          setSelectedProductIds(selectedIds);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleCheckboxChange = (productId: number, checked: boolean) => {
    setSelectedProductIds((prev) =>
      checked ? [...prev, productId] : prev.filter((id) => id !== productId)
    );
  };

  const handleAddProducts = async () => {
    const payload = { product_ids: selectedProductIds };
    WeeklyProductsService.addProducts(payload)
      .then(() => {
        setIsModalVisible(false);
        setLoading(true);
        WeeklyProductsService.getAllProducts()
          .then((response) => {
            if (Array.isArray(response?.data?.data)) {
              const dataWithKeys = response?.data?.data?.map(
                (item: WeeklyProdcutsDataType, index: number) => ({
                  ...item,
                  key: index + 1,
                })
              );
              setWeeklyProducts(dataWithKeys);
              const selectedIds = dataWithKeys.map(
                (item: WeeklyProdcutsDataType) => item.product.id
              );
              setSelectedProductIds(selectedIds);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch((error) => {
        console.error("Məhsullar əlavə edilərkən xəta baş verdi:", error);
      });
  };

  const handleProductsModal = () => {
    setIsModalVisible(true);
    ProductsService.getAllProducts(currentPage, pageSize).then((res) => {
      setProducts(res?.data?.data);
      setTotalCount(res?.data?.count);
      setCurrentPage(1);
    });
  };
  const columns: TableProps<WeeklyProdcutsDataType>["columns"] = [
    {
      title: "№",
      dataIndex: "key",
      sorter: (a, b) => (a.key ?? 0) - (b.key ?? 0),
    },
    {
      title: "Məhsullar",
      dataIndex: "product",
      render: (product) => <p>{product?.name}</p>,
    },
    {
      title: "Məhsul təsviri",
      dataIndex: "product",
      render: (product) => <p>{product?.description}</p>,
    },
  ];
  useEffect(() => {
    if (isModalVisible) {
      ProductsService.getAllProducts(currentPage, pageSize).then((res) => {
        setProducts(res?.data?.data);
        setTotalCount(res?.data?.count);
      });
    }
  }, [currentPage, pageSize, isModalVisible]);

  return (
    <div id="pages">
      <Helmet>
        <title>BSC | Həftənin seçilmişləri</title>
      </Helmet>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          <div className="page_head">
            <h3 className="page_title">Həftənin seçilmişləri</h3>
          </div>
          <div className="pages_components">
            <MainButton onClick={() => handleProductsModal()}>
              <FaEdit size={20} />
            </MainButton>
            <div className="pages_table">
              <Table<WeeklyProdcutsDataType>
                scroll={{ x: "100%" }}
                columns={columns}
                dataSource={weeklyProducts}
                rowKey={(record) => record.id.toString()}
                pagination={false}
              />
            </div>
          </div>
        </div>
      )}

      <Modal
        title={"Məhsulları əlavə edin"}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={"100%"}
        style={{ minWidth: "340px" }}
        centered
      >
        <div className={styles.add_product}>
          <div className={styles.paginations}>
            <div className={styles.search}>
              <Input placeholder="Məhsulu axtarın..." />
            </div>
            <div>
              <div className={styles.pagination_controls}>
                <div>
                  <button
                    onClick={() => setCurrentPage(1)}
                    disabled={currentPage === 1}
                  >
                    Əvvəl
                  </button>
                  <button
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    disabled={currentPage === 1}
                  >
                    Geri
                  </button>
                </div>
                <span>
                  Səhifə {currentPage} / {Math.ceil(totalCount / pageSize)}
                </span>
                <div>
                  <button
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    disabled={currentPage === Math.ceil(totalCount / pageSize)}
                  >
                    İrəli
                  </button>
                  <button
                    onClick={() =>
                      setCurrentPage(Math.ceil(totalCount / pageSize))
                    }
                    disabled={currentPage === Math.ceil(totalCount / pageSize)}
                  >
                    Son
                  </button>
                </div>
              </div>
              <div className={styles.page_size_controls}>
                <label>Hər səhifədə məhsul sayı:</label>
                <select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
            </div>
          </div>
          <h1 className={styles.title}>Məhsullar</h1>
          <form action="">
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "30px 0",
                }}
              >
                <Spin size="large" />
              </div>
            ) : (
              <div className={styles.product_checkbox_wrapper}>
                {products.map((product) => (
                  <div
                    className={styles.product_card}
                    key={product.id}
                    onClick={() =>
                      handleCheckboxChange(
                        product.id,
                        !selectedProductIds.includes(product.id)
                      )
                    }
                  >
                    <div className={styles.product_checkbox}>
                      <input
                        type="checkbox"
                        name={product.name}
                        id={product.name}
                        checked={selectedProductIds.includes(product.id)}
                        onChange={(e) =>
                          handleCheckboxChange(product.id, e.target.checked)
                        }
                      />
                      <h3>{product.name}</h3>
                    </div>
                    <div className={styles.product}>
                      {product.cover_image ? (
                        <div className={styles.product_img}>
                          <img src={product.cover_image} alt="" />
                        </div>
                      ) : null}
                      {product.discount_price ? (
                        <div className={styles.product_price}>
                          <p className={styles.price}>{product.price} AZN</p>
                          <p>{product.discount_price} AZN</p>
                        </div>
                      ) : (
                        <div className={styles.product_price}>
                          <p>{product.price} AZN</p>
                        </div>
                      )}
                      <p>
                        {product.description?.length > 50
                          ? product.description.substring(0, 50) + "..."
                          : product.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className={styles.add_product_btn}>
              <MainButton onClick={handleAddProducts}>Əlavə edin</MainButton>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default WeeklyPicks;
